import { combineReducers, createFeature } from '@ngrx/store';

import { surveyCreationAudienceReducer } from './audience/survey-creation-audience.reducer';
import { insightsReducer } from './insights/survey-creation-insights.reducer';
import { surveyCreationReferenceReducer } from './reference/survey-creation-reference.reducer';
import { SurveyCreationState } from './survey-creation-state.model';

export const surveyCreationFeatureKey = 'surveyCreation';

const surveyCreationReducer = combineReducers<SurveyCreationState>({
  audience: surveyCreationAudienceReducer,
  insights: insightsReducer,
  reference: surveyCreationReferenceReducer,
});

export const surveyCreationFeature = createFeature({
  name: surveyCreationFeatureKey,
  reducer: surveyCreationReducer,
});
